/*
 * Public API Surface of ng2-nouislider
 */

export * from './lib/ng2-nouislider.component';
export * from './lib/ng2-nouislider.module';
